import { useEffect, useState } from "react";
import "./TeacherViewCourse.css";
import DefaultCourseImage from "../../../../../assets/images/student-course-bg-image.png";
import { useAuth } from "../../../../../features/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router";
import DataTableListing from "../../../../../components/DataTableListing/DataTableListing";
import { Link } from "react-router";

import {
  fetchCourseDetails,
  fetchLessons,
  fetchStudents,
} from "../../../../../state/actions/getEnrolledCoursesDataAction";
import LessonCard from "../teacher/course/LessonCard";
import LoadingComponent from "../../../../../components/LoadingComponent/LoadingComponent";
import FloatingAIButton from "../../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../state/reducers/chatDrawerReducers";

const TeacherViewCourse = () => {
  const [activeTab, setActiveTab] = useState("lessons");
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { token } = useAuth();

  const globalState = useSelector((state) => state.globalState);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const location = useLocation();
  const roleFromState = location.state?.role;
  const roleType = roleFromState ||globalState?.teacher_details?.data?.teacher_department_roles;
  const role = globalState?.role
  const { id } = useParams();
  const isAdmin = globalState?.role === "Admin";  // check if admin
  const teacherId = location.state?.teacher_id
 const is_ls_advisor = roleType === "learning specialist" || roleType === "advisor";
  const { course, lessons, students, loading, total_students } = useSelector(
    (state) => state.EnrolledCourseData,
  );

  // Removed unused handleViewAssignment function

  useEffect(() => {
    dispatch(fetchCourseDetails(id, token));
    dispatch(fetchLessons(id, token));
    dispatch(fetchStudents(id, token, is_ls_advisor, isAdmin ? teacherId : undefined));
  }, [dispatch, token, id, is_ls_advisor]);

  useEffect(() => {
    if (activeTab === "students") {
      dispatch(fetchStudents(id, token, is_ls_advisor, isAdmin ? teacherId : undefined));
    } else if (activeTab === "lessons") {
      dispatch(fetchLessons(id, token));
    } 
  }, [activeTab, currentPage, dispatch, token, id, is_ls_advisor]);
  const studentsData =
    students?.map((s) => ({
      key: s.student_id,
      name: s.student_name || "",
      studentId: s.student_id,
      grade: s.student_grade || "",
      email: s.student_email || "",
      enrolledOn: s.enrolled_on,
      avatar: s.student_profile_pic || null,
    })) || [];

  const studentColumns = [
    {
      key: "name",
      title: "Student Name",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {row.avatar ? (
            <img
              src={row.avatar}
              alt={value}
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                color: "#94a3b8",
                fontWeight: 600,
              }}
            >
              {value?.charAt(0)}
            </div>
          )}

          <span>{value}</span>
        </div>
      ),
    },

    { key: "studentId", title: "Student ID" },

    { key: "grade", title: "Grade" },

    { key: "email", title: "Email ID" },

    {
      key: "enrolledOn",
      title: "Enrolled On",
      render: (v) =>
        v
          ? new Date(v)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              .replace(/ (\d{4})$/, ", $1")
          : "-",
    },

    {
      key: "action",
      title: "Action",
      render: (_, row) => (
        <Link
          to={`/student/${row.studentId}`}
          style={{
            color: "#0068FF",
            fontSize: 13.5,
            fontWeight: 500,
            textDecoration: "none",
          }}
        >
          View Profile
        </Link>
      ),
    },
  ];
  const accessControl = false;
  return (
    <div className="view-course-Details-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div
              className="view-course-Details-back-btn-folder"
              style={{ marginBottom: "20px" }}
              onClick={() => {
                sessionStorage.removeItem("page");

                navigate(-1);
              }}
            >
              <i className="fa-solid fa-chevron-left"></i> Back
            </div>

            <div className="course-header">
              <div className="course-image">
                <img src={course?.image || DefaultCourseImage} alt="course" />
              </div>

              <div className="course-details">
                <div className="created-my-courses-title-wrapper">
                  <h2 className="course-title">{course?.name}</h2>
                  {globalState.enabled_modules?.includes('marketplace') && (
                    <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                        <a> <i className="fa-solid fa-star"></i> </a>
                        <p className="rate">{course?.average_course_rating || "0"}</p>
                        <p className="number">({parseInt(course?.rating_count || 0)})</p>
                    </div>
                  )}
                </div>

                <p className="course-description">{course?.description}</p>

                <div className="course-stats">
                  <div className="stat-item">
                    <p>Total Lessons</p>
                    <span className="chip lesson-chip">
                      {course?.total_lessons} Lesson
                      {course?.total_lessons !== 1 ? "s" : ""}
                    </span>
                  </div>

                  <div className="stat-item">
                    <p>Students Enrolled</p>
                    <span className="chip student-chip">
                      {course?.enrolled_students} Student
                      {course?.enrolled_students !== 1 ? "s" : ""}
                    </span>
                  </div>

                  <div className="stat-item">
                    <p>Course Start Date</p>
                    <span className="chip start-chip">
                      {course?.start_date
                        ? new Date(course.start_date)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .replace(/ (\d{4})$/, ", $1")
                        : "-"}
                    </span>
                  </div>

                  <div className="stat-item">
                    <p>Course Expiry Date</p>
                    <span
                      className="chip expiry-chip"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      {course?.end_date || "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="course-tabs">
              <div
                className={`tab ${activeTab === "lessons" ? "active" : ""}`}
                onClick={() => setActiveTab("lessons")}
              >
                Lessons ({course?.total_lessons})
              </div>

              <div
                className={`tab ${activeTab === "students" ? "active" : ""}`}
                onClick={() => setActiveTab("students")}
              >
                My Students ({students?.length})
              </div>
            </div>

            {activeTab === "lessons" &&
              (lessons?.length === 0 ? (
                <div
                  className="no-lessons-placeholder"
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#666",
                    fontSize: "16px",
                    background: "#fafafa",
                    borderRadius: "8px",
                  }}
                >
                  No lessons have been added to this course yet.
                </div>
              ) : (
                lessons?.map((lesson) => (
                  <LessonCard
                  accessControl={accessControl}
                    key={lesson.lesson_id}
                    lesson={lesson}
                    course={course}
                    teacher_id={globalState?.teacher_details?.data?.teacher_id}
                    hideActions={false}
                    roleFromState={location.state?.role}
                  />
                ))
              ))}

            {activeTab === "students" && (
              <div style={{ marginTop: "20px" }}>
                <DataTableListing
                  columns={studentColumns}
                  dataSource={studentsData}
                  rowKey="key"
                  loading={loading}
                  pagination={{
                    currentPage: currentPage,
                    total: total_students || 0,
                    onChange: (page) => setCurrentPage(page),
                  }}
                  checkable={false}
                  emptyText="No students enrolled in this course"
                />
              </div>
            )}

            { role !== "Admin" &&
             <FloatingAIButton
                onClick={() => {
                dispatch(setDrawerState(!chatDrawerState.isOpen));
                dispatch(setIsWebAllowed(true));
                dispatch(setQueryMetaData(null));
                }}
            />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherViewCourse;
